<template>
  <!-- Waiting Pass View - Shown when the pass is in waiting status -->
  <div class="p-4">
    <!-- Status bar showing waiting message and time -->
    <div
      class="bg-white p-3 rounded-30 d-flex justify-content-between align-items-center"
    >
      <!-- Waiting status message -->
      <div class="text-black-50">
        {{ $t("common.currently_waiting_for_approval") }}
      </div>

      <!-- Right section with cancel request option and timer -->
      <div class="d-flex align-items-center flex-shrink-0">
        <!-- Cancel request button - only for student or teacher passes -->
        <div
          v-if="activePass?.type === 'STU' || activePass?.type === 'TCH'"
          class="text-black-50 d-flex align-items-center"
          @click="$emit('open-cancel-modal')"
          data-test-id="student-active-pass-cancel-request"
        >
          <i class="flaticon-forbidden text-red me-1 mb-1" />
          {{ $t("common.cancel_request") }}
        </div>

        <!-- Request timer display -->
        <div
          class="bg-red-gradient py-2 px-3 rounded-30 ms-2 text-center text-white"
          id="active-pass-time-in-request"
        >
          {{ timeInRequest }}
        </div>
      </div>
    </div>

    <!-- Pass information container -->
    <div
      class="bg-white rounded-30 d-flex flex-column justify-content-between align-items-center m-0 mt-3"
    >
      <!-- Comments section -->
      <PassCommentsList :comments="comments" />

      <!-- Timer component -->
      <PassTimer
        :active-pass="activePass"
        :time-in-pass="timeInPass"
        :current-status="currentStatus"
        :is-pass-long-running="isPassLongRunning"
        :pin-attempts-count="pinAttemptsCount"
        :is-active-auto-check-in-module="isActiveAutoCheckInModule"
        @auto-approve="$emit('auto-approve')"
      />
    </div>
  </div>
</template>

<script>
import PassCommentsList from "./PassCommentsList.vue"
import PassTimer from "./PassTimer.vue"

export default {
  name: "WaitingPassView",
  components: {
    PassCommentsList,
    PassTimer
  }
}
</script>

<script setup>
defineProps({
  activePass: {
    type: Object,
    default: () => ({})
  },
  comments: {
    type: Array,
    default: () => []
  },
  timeInRequest: {
    type: String,
    default: ""
  },
  timeInPass: {
    type: String,
    default: ""
  },
  currentStatus: {
    type: String,
    default: ""
  },
  isPassLongRunning: {
    type: Boolean,
    default: false
  },
  pinAttemptsCount: {
    type: Number,
    default: 0
  },
  isActiveAutoCheckInModule: {
    type: Boolean,
    default: false
  }
})

// Define emits
defineEmits(["open-cancel-modal", "auto-approve"])
</script>
